AdolopmentRecommendationDecisionSection =
  require 'components/etd/adolopment_recommendation_decision_section'
AdolopmentSectionSeparator = require 'components/etd/adolopment_section_separator'
ConclusionsSectionTitleRow =  require 'components/etd/conclusions_section_title_row'
ConclusionsTextSection = require 'components/etd/conclusions_text_section'
ConnectStores = require 'components/enhancers/connect_store'
CustomRenderMixin = require 'components/mixins/custom_render_mixin'
EllipsizedText = require 'components/common/ellipsized_text'
EtdActions = require 'actions/etd_actions'
EtdStore = require 'stores/etd_store'
EtdsStore = require 'stores/etds_store'
mediator = require 'mediator'
Router = require 'router'
QuestionsStore = require 'stores/questions_store'
QuestionsHelper = require 'lib/questions_helper'
QuestionGroupsStore = require 'stores/question_groups_store'
RecommendationMetadata = require 'components/etd/recommendation_metadata'
RelatedEvidences = require 'components/etd/related_evidences'
RelatedRecommendation = require 'components/etd/related_recommendation'
RelatedRecommendations = require 'components/etd/related_recommendations'
GenerateRecommendationButton = require 'components/etd/generate_recommendation_button'
RemarksSection = require 'components/etd/remarks_section'
Translation = require 'components/mixins/translation'
UserProjectDataActions = require 'actions/user_project_data_actions'
{ getRelatedRecommendations } = require 'lib/etds_helper'
{ getConsensusBasedField } = require 'lib/etd_helper'

toggleOriginalSection = (etdId, sectionId) -> ->
  UserProjectDataActions.toggleOriginalDataSection etdId, sectionId

toggleAdolopmentSection = (etdId, sectionId) -> ->
  UserProjectDataActions.toggleAdolopmentDataSection etdId, sectionId

storeConnectors =
  EtdStore: (Store) ->
    relatedQuestionsIds: Store.getRelatedQuestionsIds()
    hiddenRelatedQuestions: Store.getHiddenRelatedQuestions()
    relatedEvidenceIds: Store.getRelatedEvidenceIds()
    hiddenRelatedEvidence: Store.getHiddenRelatedEvidence()
  EtdsStore: (Store) ->
    etds: Store.getEtds()
  QuestionsStore: (Store) ->
    questions: Store.getQuestions()
  QuestionGroupsStore: (Store) ->
    questionGroups: Store.getQuestionGroups()

RecommendationDecisionSection = createReactClass

  displayName: "RecommendationDecisionSection"
  mixins: [CustomRenderMixin, Translation('es:recommendations.table')]

  propTypes:
    adolopmentData: PropTypes.instanceOf(Immutable.Map).isRequired
    adolopments: PropTypes.instanceOf(Immutable.Map).isRequired
    contentColSpan: PropTypes.number,
    etdId: PropTypes.string.isRequired,
    etdViewSettings: PropTypes.instanceOf(Immutable.Map).isRequired
    hiddenRelatedEvidence: PropTypes.instanceOf(Immutable.List).isRequired
    hiddenRelatedQuestions: PropTypes.instanceOf(Immutable.List).isRequired
    isConsensus: PropTypes.bool,
    readOnly: PropTypes.bool
    relatedEvidenceIds: PropTypes.instanceOf(Immutable.List).isRequired
    relatedQuestionsIds: PropTypes.instanceOf(Immutable.List).isRequired
    renderMode: PropTypes.string
    section: PropTypes.instanceOf(Immutable.Map).isRequired

  addRemarks: ->
    EtdActions.addRemarks { sectionId: @props.sectionId }

  toggleRelatedQuestion: (relatedQuestionId) -> (e) ->
    e.stopPropagation() # stopping propagation so it won't open edit modal window in panelvoice
    EtdActions.toggleRelatedQuestion relatedQuestionId

  render: ->
    # apply 'content' class to all text sectionections. here also checking 'options'
    # property because type of recommendation section has both 'content' and 'options'
    # props, while we shouldn't consider it a 'content' cell section (rather optionsTypeSection)

    {
      adolopmentData
      adolopments
      attachments
      contentColSpan
      editable
      etdId
      etds
      etdViewSettings
      hiddenRelatedEvidence
      hiddenRelatedQuestions
      highlightToPanelMembers
      isConsensus
      onEditClick
      questionGroups
      questions
      readOnly
      relatedEvidenceIds
      relatedQuestionsIds
      renderMode
      section
      sectionId
      showResultingDataOnly
      withAdolopment
    } = @props

    contentCellClass = classNames
      content: section.get('content')? and not section.get 'options'
      highlighted: highlightToPanelMembers

    sectionToBeDisplayedAsCurrent = if adolopments.isEmpty()
      section
    else if withAdolopment
      section
    else
      adolopment = adolopments.last()
      adolopment.getIn ['templateData', 'conclusions', 'sections', sectionId]

    originalSectionCollapsed = etdViewSettings.getIn(
      ['collapsedOriginalSections', sectionId], false)

    adolopmentSectionCollapsed = etdViewSettings.getIn(
      ['collapsedAdolopmentSections', sectionId], false)

    editable = editable and (adolopments.isEmpty() or withAdolopment)

    sectionKey = if not adolopments.isEmpty() and withAdolopment
      'adolopment'
    else
      'original'

    readOnly = if adolopments.isEmpty()
      readOnly
    else if withAdolopment
      readOnly
    else
      true

    relatedQuestions = QuestionsHelper.getRelatedQuestions questionGroups, questions,
      relatedQuestionsIds
    relatedRecommendations = getRelatedRecommendations(etds, relatedQuestions)

    relatedEvidences = QuestionsHelper.getRelatedQuestions questionGroups, questions,
      relatedEvidenceIds

    rows = []
    if not adolopments.isEmpty() and withAdolopment and not showResultingDataOnly
      rows = rows.concat [
        <tbody key={1}>
          <AdolopmentSectionSeparator
            i18n={@i18n}
            section="original"
            type="conclusions"
            onClick={toggleOriginalSection(etdId, sectionId)}
          />
        </tbody>
        <AdolopmentRecommendationDecisionSection
          adolopments={adolopments}
          attachments={attachments}
          contentCellClass={contentCellClass}
          i18n={@i18n}
          isConsensus={isConsensus}
          key={"#{sectionId}-adolopments"}
          section={section}
          sectionId={sectionId}
        />
        <tbody key={3}>
          <AdolopmentSectionSeparator
            i18n={@i18n}
            section="adolopment"
            type="conclusions"
            onClick={toggleAdolopmentSection(etdId, sectionId)}
          />
        </tbody>
      ]
    if not adolopmentSectionCollapsed or showResultingDataOnly
      rows.push <tbody key={4} onClick={onEditClick unless readOnly}>
        <tr>
          <td
            className={contentCellClass}
            colSpan={contentColSpan}
          >
            {if sectionToBeDisplayedAsCurrent.has 'content'
              <React.Fragment>
                <ConclusionsTextSection
                  attachments={attachments}
                  cellId={"#{sectionId}#conclusions"}
                  className="recommendation-editor-container"
                  content={getConsensusBasedField(sectionToBeDisplayedAsCurrent, 'content', isConsensus) or null}
                  editable={editable}
                  isConsensus={isConsensus}
                  renderMode={renderMode}
                />
                <RemarksSection
                  editable={editable}
                  renderMode={renderMode}
                  sectionId={sectionId}
                  remarks={sectionToBeDisplayedAsCurrent.get('remarks', Immutable.Map())}
                />
              </React.Fragment>
            else
              throw new Error 'Unsupported conclusions section'
            }
          </td>
        </tr>
        {renderMode isnt 'printout' and <tr>
          <td colSpan={contentColSpan}>
            <div className="w-full flex justify-end items-center gap-10 mt-10">
              <RelatedEvidences
                editable={editable}
                renderMode={renderMode}
              />
              <RelatedRecommendations
                editable={editable}
                renderMode={renderMode}
              />
              <GenerateRecommendationButton
                editable={editable}
                isConsensus={isConsensus}
              />
              <RecommendationMetadata editable={editable} />
            </div>
          </td>
        </tr>}
        {!relatedQuestions.isEmpty() && <tr>
          <td colSpan={contentColSpan}>
            {not relatedQuestions.isEmpty() and
              <div className="related-recommendations__caption conclusions-section-title mt-10">
                <h2>{@i18n '../related_recommendations'}</h2>
              </div>
            }
            {relatedQuestions.mapEntries ([questionId, question], index) =>
              rrList = relatedRecommendations.get(questionId, Immutable.Map()).map (etd, etdId) =>
                <RelatedRecommendation
                  index={index}
                  renderMode={renderMode}
                  key={etdId}
                  question={question}
                  onToggle={@toggleRelatedQuestion(questionId)}
                  expanded={hiddenRelatedQuestions.get(questionId, false) or renderMode is 'printout'}
                  relatedRecommendation={etd}
                />
              [questionId, rrList.toList()]
            .toList()
            }
          </td>
        </tr>
        }
        {!relatedEvidences.isEmpty() && <tr>
          <td colSpan={contentColSpan}>
            <div className="mb-20">
              {not relatedEvidences.isEmpty() and
                <div className="related-recommendations__caption conclusions-section-title mt-10">
                  <h2>{@i18n '../related_evidences'}</h2>
                </div>
              }
              {relatedEvidences.mapEntries ([questionId, question], index) ->
                re = <RelatedEvidence
                  key={questionId}
                  index={index}
                  question={question}
                  renderMode={renderMode}
                />
                [questionId, re]
              .toList()}
            </div>
          </td>
        </tr>}
      </tbody>

    <table className="standard-table recommendation-table-static">
      <tbody>
        <ConclusionsSectionTitleRow
          title={section.get('description')}
          subTitle={section.get('subTitle')}
          colSpan={contentColSpan}
          renderMode={renderMode}
        />
      </tbody>
      {rows}
    </table>

RelatedEvidence = ({ question, renderMode, index }) ->

  goToQuestion = (questionId) -> ->
    route = Router::routeForSubmodule 'evidence_syntheses', "quality-of-evidence", { questionId }
    mediator.publish '!router:route', route

  <div className="related-recommendation">
    <div className="related-recommendation__question">
      {if renderMode is 'printout'
        <div><b>{index + 1}. {question.get('question', '')}</b></div>
      else
        <div className="caption" onClick={goToQuestion(question.get('_id'))}>
          <EllipsizedText
            text={question.get('question', '')}
            height={40}
          />
        </div>}
    </div>
  </div>

module.exports = ConnectStores RecommendationDecisionSection,
  [EtdStore, EtdsStore, QuestionsStore, QuestionGroupsStore], storeConnectors
